export class FileTypes {
  static imageExtensions = ['.jpeg', '.png', '.jpg', '.heic'];
  static logoExtensions = ['.jpeg', '.png', '.jpg', '.svg', '.heic'];
  static allExtensions = ['.jpeg', '.png', '.jpg', '.svg', '.heic'];
  static zipExtention = ['zip'];
}
